import { defineComponent as _defineComponent } from 'vue'
import ClickMenu from '@/components/menu/ClickMenu.vue';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { translateFilterTimeAxisSpanEnum } from '@/utils/i18n';
import { computed, onMounted, watch } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'DateGroupingFilter',
  props: {
    value: { default: FilterTimeAxisSpanEnum.Day },
    position: { default: 'is-bottom-left' },
    hasNoneOption: { type: Boolean, default: false },
    hasHourOption: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: FilterTimeAxisSpanEnum) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value: FilterTimeAxisSpanEnum, position: string, hasNoneOption: boolean, hasHourOption: boolean };





onMounted(() => {
  if (
    (!props.hasNoneOption && props.value === FilterTimeAxisSpanEnum.None) ||
    (!props.hasHourOption && props.value === FilterTimeAxisSpanEnum.Hour)
  ) {
    emit('input', FilterTimeAxisSpanEnum.Day);
  }
});

function emitValue(event: string | number | (string | number)[]) {
  emit('input', event as FilterTimeAxisSpanEnum);
}

const ids = computed<FilterTimeAxisSpanEnum[]>(() =>
  Object.values(FilterTimeAxisSpanEnum)
    .filter((value) => !isNaN(Number(value)))
    .filter(
      (value) =>
        value !== FilterTimeAxisSpanEnum.None ||
        (value === FilterTimeAxisSpanEnum.None && props.hasNoneOption),
    )
    .filter(
      (value) =>
        value !== FilterTimeAxisSpanEnum.Hour ||
        (value === FilterTimeAxisSpanEnum.Hour && props.hasHourOption),
    )
    .map(Number),
);

const names = computed<string[]>(() =>
  ids.value.map((id) => translateFilterTimeAxisSpanEnum(id)),
);

watch(
  () => props.hasNoneOption,
  () => {
    if (!props.hasNoneOption && props.value === FilterTimeAxisSpanEnum.None) {
      emit('input', FilterTimeAxisSpanEnum.Day);
    }
  },
);

watch(
  () => props.hasHourOption,
  () => {
    if (!props.hasHourOption && props.value === FilterTimeAxisSpanEnum.Hour) {
      emit('input', FilterTimeAxisSpanEnum.Day);
    }
  },
);

return { __sfc: true,props, emit, emitValue, ids, names, ClickMenu, translateFilterTimeAxisSpanEnum }
}

})